import { TbAsterisk, TbCheck, TbInfoCircle } from "react-icons/tb";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const MandatorySign = ({ message, icon = "asterisc", size = "10px", direction = "top" }) => {
    const renderTooltip = (props) => (
        <Tooltip className="mandatory_tooltip" {...props}>
            <div dangerouslySetInnerHTML={{ __html: message }}></div>
        </Tooltip>
    );

    return (
        <OverlayTrigger
            placement={direction}
            trigger={["hover", "focus"]}
            rootClose
            overlay={renderTooltip}
        >
            <div className="mandatory_sign_cont">
                {icon === "asterisc" ? (
                    <i style={{ fontSize: size }}>
                        <TbAsterisk />
                    </i>
                ) : icon === "check" ? (
                     <i style={{ fontSize: size }}>
                        <TbCheck />
                    </i>
                ) : (
                    <i style={{ fontSize: size }}>
                        <TbInfoCircle />
                    </i>
                )}
            </div>
        </OverlayTrigger>
    );
};

export default MandatorySign;